import { Request } from '../request';

export const getProviderInsurancesListByProviderId = (providerId: number) => Request.get({ url: `/admin-server/provider/uniprofile/insurances/${providerId}` });
